var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("运动膳食")]),_c('el-transfer',{ref:"TransferRef",staticStyle:{"text-align":"left","display":"inline-block"},attrs:{"filterable":"","props":{ key: 'id', label: 'presName' },"titles":['未选', '已选'],"format":{
            noChecked: '${total}',
            hasChecked: '${checked}/${total}'
        },"data":_vm.presSport},model:{value:(_vm.stashPresSport),callback:function ($$v) {_vm.stashPresSport=$$v},expression:"stashPresSport"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }